import React from "react";
import { Button, Modal, ModalBody } from "reactstrap";
import { Icon } from "../Component";

const DeleteModal = ({ isOpen, onClose, size = "md", onFormCancel, deleteFunc, title }) => {
  return (
    <Modal isOpen={isOpen} toggle={onClose} className="modal-dialog-centered" size={size}>
      <ModalBody>
        <a
          href="#cancel"
          onClick={(ev) => {
            ev.preventDefault();
            onFormCancel();
          }}
          className="close"
        >
          <Icon name="cross-sm" />
        </a>
        <div className="p-2">
          <h5 className="title">Delete: {title}</h5>
          <div className="mt-4 d-flex align-items-center justify-content-center">
            <Button onClick={deleteFunc} color="danger" size="lg">
              Delete
            </Button>
            <Button onClick={onFormCancel} className="ml-2" color="secondary" size="lg">
              Cancel
            </Button>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default DeleteModal;
